/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewDomainExpansionItem } from './CRSFSecReviewDomainExpansionItem';
import {
    CRSFSecReviewDomainExpansionItemFromJSON,
    CRSFSecReviewDomainExpansionItemFromJSONTyped,
    CRSFSecReviewDomainExpansionItemToJSON,
} from './CRSFSecReviewDomainExpansionItem';

/**
 * 
 * @export
 * @interface CRSFSecReviewDomainExpansionPagedResponse
 */
export interface CRSFSecReviewDomainExpansionPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDomainExpansionPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDomainExpansionPagedResponse
     */
    page_size?: number;
    /**
     * 
     * @type {Array<CRSFSecReviewDomainExpansionItem>}
     * @memberof CRSFSecReviewDomainExpansionPagedResponse
     */
    results?: Array<CRSFSecReviewDomainExpansionItem>;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDomainExpansionPagedResponse
     */
    total?: number;
}

/**
 * Check if a given object implements the CRSFSecReviewDomainExpansionPagedResponse interface.
 */
export function instanceOfCRSFSecReviewDomainExpansionPagedResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFSecReviewDomainExpansionPagedResponseFromJSON(json: any): CRSFSecReviewDomainExpansionPagedResponse {
    return CRSFSecReviewDomainExpansionPagedResponseFromJSONTyped(json, false);
}

export function CRSFSecReviewDomainExpansionPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewDomainExpansionPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(CRSFSecReviewDomainExpansionItemFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function CRSFSecReviewDomainExpansionPagedResponseToJSON(value?: CRSFSecReviewDomainExpansionPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(CRSFSecReviewDomainExpansionItemToJSON)),
        'total': value.total,
    };
}

